/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon24Solid = forwardRef('ArrowUiAuthLogoutIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-4.998h5.464l-2.36 2.36a1.5 1.5 0 1 0 2.12 2.122l3.862-3.861a3 3 0 0 0 0-4.243L19.225 5.52a1.5 1.5 0 1 0-2.122 2.121l2.362 2.362H14V6a4 4 0 0 0-4-4H4Zm10 8.002H7.5a1.5 1.5 0 0 0 0 3H14v-3Z" })));
});
